import { createActionHelpers } from 'vuex-loading';

const { startLoading, endLoading } = createActionHelpers({
    moduleName: 'loading',
});

const actions = {
    sync({ commit, dispatch }, id) {
        startLoading(dispatch, 'sync');

        return axios
            .post(Laroute.route('inventory.sync.sync', { id }))
            .then(res => {
                endLoading(dispatch, 'sync');
                return res;
            })
            .catch(err => {
                endLoading(dispatch, 'sync');
                throw err;
            });
    },

    async syncOutlet({ commit, dispatch }) {
        const url = Laroute.route('inventory.sync.outlet');

        startLoading(dispatch, 'sync-outlet');

        try {
            await axios.get(url);
            endLoading(dispatch, 'sync-outlet');
        } catch (e) {
            endLoading(dispatch, 'sync-outlet');
            throw e;
        }
    },

    async syncProduct({ commit, dispatch }, id) {
        const url = Laroute.route('inventory.sync.product', { id });

        startLoading(dispatch, 'sync-product');

        try {
            await axios.get(url);
            endLoading(dispatch, 'sync-product');
        } catch (e) {
            endLoading(dispatch, 'sync-product');
            throw e;
        }
    },

    async syncVariant({ commit, dispatch }, id) {
        const url = Laroute.route('inventory.sync.variant', { id });

        startLoading(dispatch, 'sync-variant');

        try {
            await axios.get(url);
            endLoading(dispatch, 'sync-variant');
        } catch (e) {
            endLoading(dispatch, 'sync-variant');
            throw e;
        }
    },

    async syncStock({ commit, dispatch }, id) {
        const url = Laroute.route('inventory.sync.stock', { id });

        startLoading(dispatch, 'sync-stock');

        try {
            await axios.get(url);
            endLoading(dispatch, 'sync-stock');
        } catch (e) {
            endLoading(dispatch, 'sync-stock');
            throw e;
        }
    },

    async syncTag({ commit, dispatch }) {
        const url = Laroute.route('inventory.sync.tag');

        startLoading(dispatch, 'sync-tag');

        try {
            await axios.get(url);
            endLoading(dispatch, 'sync-tag');
        } catch (e) {
            endLoading(dispatch, 'sync-tag');
            throw e;
        }
    },

    async syncProductTag({ commit, dispatch }, id) {
        const url = Laroute.route('inventory.sync.product.tag', { id });

        startLoading(dispatch, 'sync-product-tag');

        try {
            await axios.get(url);
            endLoading(dispatch, 'sync-product-tag');
        } catch (e) {
            endLoading(dispatch, 'sync-product-tag');
            throw e;
        }
    },
};

export default {
    namespaced: true,
    actions,
};



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/inventory-sync.js